<template>
    <div class="content">
        <table class="data-table">
            <thead>
                <tr>
                    <th>
                        广告位
                    </th>
                    <th>
                        展现人数
                    </th>
                    <th>
                        展示次数
                    </th>
                    <th>
                        点击人数
                    </th>
                    <th>
                        点击次数
                    </th>
                    <th>
                        点击率
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(pos, i) in positions" :key="i">
                    <td>{{ pos.position }}</td>
                    <td>{{ pos.view_users }}</td>
                    <td>{{ pos.view_times }}</td>
                    <td>{{ pos.click_users }}</td>
                    <td>{{ pos.click_times }}</td>
                    <td>{{ pos.click_times ? (pos.click_users / pos.view_users * 100).toFixed(2) : 0 }}%</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: {
        positions: {
            type: Array,
            default: () => ([])
        },
        dashboard: {
            type: Object,
            default: () => ({})
        },
        building: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>
<style scoped lang="scss">
</style>
